import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

export function PieChart(props) {
  const { data } = props;

  const matches = useMediaQuery('(max-width:800px)');

  const [percentage, setPercentage] = useState([]);
  const [categories, setCategories] = useState([]);
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(true);

  const options = {
    chart: { type: 'donut' },
    labels: categories,
    colors,
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'left',
      onItemHover: { highlightDataSeries: false },
      fontSize: matches ? '12px' : '14px',
      fontFamily: 'Montserrat, Arial',
      fontWeight: 500,
      offsetX: 32,
      offsetY: 4,
      width: matches ? 350 : 480,
      formatter: (seriesName, opts) =>
        `${seriesName} ${opts.w.globals.series[opts.seriesIndex]}%`,
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        customScale: 1,
        dataLabels: { offset: 0, minAngleToShowLabel: 20 },
        donut: {
          size: '55%',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '14px',
              fontFamily: 'Montserrat, Arial, sans-serif',
              fontWeight: 600,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: '14px',
              fontFamily: 'Montserrat, Arial, sans-serif',
              fontWeight: 600,
              offsetY: 16,
              formatter: (val) => `${val}%`,
            },
          },
        },
      },
    },
    tooltip: { y: { formatter: (val) => `${val.toFixed(2)} %` } },
    title: {
      text: 'Custos por categoria',
      margin: matches ? 22 : 16,
      offsetX: matches ? 58 : 16,
      style: {
        fontSize: matches ? '16px' : '18px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat, Arial, sans-serif',
        color: '#434242',
      },
    },
  };

  useEffect(() => {
    let timer;

    if (data.length) {
      setPercentage(data.map((percent) => parseFloat(percent.percentage)));
      setCategories(data.map((category) => category.category));
      setColors(data.map((color) => color.color));
      setLoading(false);
    } else {
      timer = setTimeout(() => {
        setLoading(false);
      }, 1500);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [data]);

  return loading ? (
    <CircularProgress />
  ) : (
    <Chart
      type="donut"
      options={options}
      series={percentage}
      width={480}
      height={380}
    />
  );
}

PieChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      color: PropTypes.string,
      percentage: PropTypes.string,
    })
  ).isRequired,
};
